// Better Auth API endpoints
export const AUTH_ENDPOINTS = {
  // Better Auth標準エンドポイント（クッキー設定が正しく動作）
  SIGN_IN: "/api/auth/sign-in/email",
  SIGN_IN_EMAIL_OTP: "/api/auth/sign-in/email-otp",
  SIGN_OUT: "/api/auth/sign-out",
  REGISTER: "/api/auth/sign-up/email",

  // Social Login エンドポイント
  SIGN_IN_LINE: "/api/auth/sign-in/social",
  LINE_LOGIN: "/api/auth/line",

  // Email OTP エンドポイント
  SEND_VERIFICATION_OTP: "/api/auth/email-otp/send-verification-otp",
  VERIFY_EMAIL_OTP: "/api/auth/email-otp/verify-email-otp",

  // カスタムエンドポイント
  ME: "/api/auth/v1/me",
  VERIFY_EMAIL: "/api/auth/v1/verifyEmail",
  VERIFY_OTP: "/api/auth/v1/verifyOTP",
  FORGOT_PASSWORD: "/api/auth/v1/forgotPassword",
  RESET_PASSWORD: "/api/auth/v1/resetPassword",
} as const;
